module.exports = __webpack_public_path__ + "static/media/login_background.bbf20fbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_background.png
// module id = 1215
// module chunks = 110